export const initScrollReveal = () => {
    // Scroll-reveal observer for elements with class 'revamp-reveal'
    const observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('revealed');
                    observer.unobserve(entry.target); // Only animate once
                }
            });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    // Observe all revamp-reveal elements
    const elements = document.querySelectorAll('.revamp-reveal');
    elements.forEach(el => observer.observe(el));

    // Return cleanup function
    return () => observer.disconnect();
};
